import { NavSection } from '@aslanpay/portal-common-lib';
import { createContext, useContext } from 'react';

interface SidebarContextValue {
  sections: NavSection[];
}

export const SidebarContext = createContext<SidebarContextValue | null>(null);

export function useSidebarContext(): SidebarContextValue {
  const context = useContext(SidebarContext);

  if (!context) throw new Error('useSidebarContext must be used within SidebarContext.Provider');

  return context;
}
